import * as tslib_1 from "tslib";
import { MdDateRange } from 'react-icons/md';
import React from 'react';
import { Selectable, SelectableContent, } from '@sinoui/selectable';
import { SimpleIcon } from 'sinoui-components/Icon';
import memoize from 'lodash/memoize';
import Calendar from './Calendar/components/Calendar';
var dateIcon = (React.createElement(SimpleIcon, null,
    React.createElement(MdDateRange, null)));
var popRender = function (_a) {
    var value = _a.value, onChange = _a.onChange, close = _a.close, todayBeforeForbidden = _a.todayBeforeForbidden, onlyYearMonth = _a.onlyYearMonth;
    return (React.createElement(Calendar, { dateTime: value, onChange: function (date) {
            onChange(null, date);
            close();
        }, todayBeforeForbidden: todayBeforeForbidden, onlyYearMonth: onlyYearMonth }));
};
var contentRender = memoize(function (border) { return function (_a) {
    var value = _a.value;
    return (React.createElement(SelectableContent, { border: border }, value));
}; });
export default function DatePicker(props) {
    return (React.createElement(Selectable, tslib_1.__assign({ baseClassName: "sinoui-date-picker", contentRender: contentRender(props.border), popRender: popRender, icon: !props.hideIcon && dateIcon }, props)));
}
//# sourceMappingURL=DatePicker.js.map